import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/alert-triangle-outline-red.svg'
import _imports_1 from '@/assets/img/icon/alert-outline-red.png'


const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-1 background-red-light-1 border-danger rounded-lg px-4 py-1.5 mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "x",
  class: "mr-2"
}, null, -1)
const _hoisted_3 = { class: "text-base" }
const _hoisted_4 = { class: "flex items-center justify-between mb-4" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Filter:", -1)
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "relative w-full md:w-80 input-icon-right" }
const _hoisted_9 = { class: "fuel-payment-batch-detail-table" }
const _hoisted_10 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "KODE BATCH"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "TANGGAL DIBUAT"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "JUMLAH NOTA"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "TOTAL (Rp)"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center" }, "STATUS"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-center w-28" }, "AKSI")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    class: "text-center py-8"
  }, "Tidak Ada Data")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_16 = { class: "font-medium text-center" }
const _hoisted_17 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "X"
}, null, -1)
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-primary font-bold" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "chip-primary-outline inline-block" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Verifikasi")
const _hoisted_27 = {
  key: 1,
  class: "mt-4"
}

import { getCurrentInstance, onMounted, ref } from 'vue'
import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import '../detail-table.scss'
import moment from 'moment'
import Paginator from '@/views/components/paginator/Paginator.vue'
import { useRouter } from 'vue-router'
import Calendar from 'primevue/calendar'
import Button from 'primevue/button'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import InputText from 'primevue/inputtext'
import Popper from 'vue3-popper'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckerVerification',
  setup(__props) {

const endpoint = 'transaction/v2/FuelingPaymentBatches'

const store = useStore()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast,
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const dataSource = ref([]) as any
const parentInputSearch = ref('')
const filterDate = ref()
const today = new Date()
const tooltipText = ref('Batch perlu segera diverifikasi!')
const isShowAlertIcon = ref(false)
const isShowAlertBanner = ref(false)
const dueDateDataCount = ref(0)
filterDate.value = []
const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  custom: [] as any,
  totalRecords: 0
})

const getAllData = () => {
  store.dispatch('showLoading')
  try {
    apiUseCase.get(`${endpoint}${returnUrlPrams(filters.value)}`).then((response) => {
      const { error, result, count } = response
      if (!error) {
        dataSource.value = result
        filters.value.totalRecords = count
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal memuat data. Silahkan coba kembali beberapa saat lagi.',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onChangePage = (evt: any) => {
  filters.value.pageNumber = evt.page + 1
  getAllData()
}

const goToDetail = (data: any) => {
  const encryptedData = encryptDecriptMethods.encrypt({ origin: 'checker', data })
  router.push({
    name: 'fuel-payment-batch-detail',
    params: {
      id: encryptedData
    }
  })
}

const onParentSearch = () => {
  filters.value.search = parentInputSearch.value
  filters.value.pageNumber = 1
  getAllData()
}

const applyDateFilter = (evt: any) => {
  const startIndex = filters.value.custom.findIndex((item: any) => item[0] === 'startDate')
  const endIndex = filters.value.custom.findIndex((item: any) => item[0] === 'endDate')

  if (startIndex !== -1) {
    filters.value.custom[startIndex][2] = moment(filterDate.value[0]).format('YYYY-MM-DD')
  } else {
    filters.value.custom.push(['startDate', '=', moment(filterDate.value[0]).format('YYYY-MM-DD')])
  }

  if (endIndex !== -1) {
    filters.value.custom[endIndex][2] = moment(filterDate.value[1]).format('YYYY-MM-DD')
  } else {
    filters.value.custom.push(['endDate', '=', moment(filterDate.value[1]).format('YYYY-MM-DD')])
  }
  filters.value.pageNumber = 1
  getAllData()
}

const isMoreThen3Days = (data: any) => moment().diff(moment(data.CreatedAt), 'days') > 3

const getDataSummary = () => {
  store.dispatch('showLoading')
  apiUseCase.get(`${endpoint}/ByStatusChangeStep/Summary`).then((response) => {
    const { error, result } = response
    // console.log('res', result)
    if (!error) {
      dueDateDataCount.value = result.filter((data: any) => data.Status === 'CheckerVerification')[0].DueDateCount
      if (dueDateDataCount.value > 0) {
        isShowAlertBanner.value = true
      }
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  filters.value.custom = [['statusChangeStep', '=', 'CheckerVerification']]
  getAllData()
  getDataSummary()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isShowAlertBanner.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(`${_unref(numberFormat)(dueDateDataCount.value)} batch lebih dari 3 hari. Segera verifikasi!`), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(Calendar), {
            modelValue: filterDate.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((filterDate).value = $event)),
              _cache[1] || (_cache[1] = ($event: any) => (applyDateFilter($event)))
            ],
            selectionMode: "range",
            dateFormat: "dd/mm/yy",
            placeholder: "Tanggal",
            class: "w-56"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(InputText), {
          modelValue: parentInputSearch.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((parentInputSearch).value = $event)),
          placeholder: "Cari kode batch",
          class: "w-full input-default",
          onKeyup: _withKeys(onParentSearch, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createElementVNode("i", {
          class: "pi pi-search text-neutral-400 cursor-pointer",
          onClick: onParentSearch
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _hoisted_11,
        (_unref(dataSource).length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, _hoisted_14))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: data.Id,
                  class: "hover:bg-neutral-50 transition-colors"
                }, [
                  _createElementVNode("td", _hoisted_16, [
                    _createTextVNode(_toDisplayString(data.Code) + " ", 1),
                    (isMoreThen3Days(data))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createVNode(_unref(Popper), {
                            arrow: "",
                            hover: "",
                            placement: "bottom",
                            content: tooltipText.value
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(data.CreatedAt ? _unref(moment)(data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss') : '-'), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(data.FuelingTransactionVerificationCount ?? 0), 1),
                    _createTextVNode(" / " + _toDisplayString(`${_unref(numberFormat)(data.TotalTransaction ?? 0)} Nota`), 1)
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(rupiahFormat)(data.TotalAmount)), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(data.StatusDisplayName || 'Sudah Dibayar'), 1)
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    _createVNode(_unref(Button), {
                      class: "btn-primary text-xs py-1.5 px-4 rounded-lg",
                      onClick: ($event: any) => (goToDetail(data))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ]))
      ])
    ]),
    (_unref(dataSource).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(Paginator, {
            rows: filters.value.pageSize,
            totalRecords: filters.value.totalRecords,
            onOnPage: onChangePage
          }, null, 8, ["rows", "totalRecords"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})